import { Button, Space } from "antd";
import { FormikProvider, useFormik } from "formik";
import { useState } from "react";
import { FaRegEdit } from "react-icons/fa";
import styled from "styled-components";
import * as Yup from "yup";

import Checkbox from "./Checkbox";
import Date from "./Date";
import DateTime from "./DateTime";
import Input from "./Input";
import InputNumber from "./InputNumber";
import Radio from "./Radio";
import Select from "./Select";

export const CONTROL_TYPE = {
  INPUT: "input",
  ZIP_CODE: "zipCode",
  INPUT_NUMBER: "inputNumber",
  CHECKBOX: "checkbox",
  SELECT: "select",
  SELECT_MULTIPLE: "select_multiple",
  RADIO: "radio",
  DATE: "date",
  DATE_V2: "date_v2",
  DATE_TIME: "dateTime",
  FILE: "file",
  PASSWORD: "password",
  PREFECTURE: "prefecture",
  PERIOD: "period",
  SEPARATELY: "separately",
  TEXT_AREA: "text_area",
  PHONE_NUMBER: "phone_number",
  INPUT_POSITIVE_NUMBER: "input_positive_number",
  DATE_TAX: "date_tax",
  REGISTER_CODE: "register_code",
  CHECKEDBOX: "checkedbox",
  BANK_ACCOUNT_DATE: "bank_account_date",
  INPUT_NEGATIVE_NUMBER: "input_negative_number",
  DATE_V3: "date_v3",
};

type FormikControlProps = {
  control: typeof CONTROL_TYPE[keyof typeof CONTROL_TYPE];
  name: string;
  [key: string]: any;
};

const FormikControl = (props: FormikControlProps) => {
  const { control, ...rest } = props;
  switch (control) {
    case CONTROL_TYPE.INPUT:
      return <Input {...rest} />;
    case CONTROL_TYPE.INPUT_NUMBER:
      return <InputNumber {...rest} />;
    case CONTROL_TYPE.CHECKBOX:
      return <Checkbox {...rest} />;
    case CONTROL_TYPE.SELECT:
      return <Select {...rest} />;
    case CONTROL_TYPE.RADIO:
      return <Radio {...rest} />;
    case CONTROL_TYPE.DATE:
      return <Date {...rest} />;
    case CONTROL_TYPE.DATE_TIME:
      return <DateTime {...rest} />;
    default:
      return null;
  }
};

export default FormikControl;

type FieldCodeProps = {
  field_code: string;
  // eslint-disable-next-line no-unused-vars
  setFieldCode: (newFieldCode: string) => void;
};

const Styles = styled.div`
  label {
    font-size: 1rem;
    span {
      margin-left: 4px;
      color: #e74c3c;
      font-size: 20px;
    }
  }
`;

export const FieldCode = ({ field_code, setFieldCode }: FieldCodeProps) => {
  const [isEditingFieldCode, setIsEditingFieldCode] = useState(false);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { field_code: field_code ?? "" },
    validationSchema: Yup.object({
      field_code: Yup.string().required(),
    }),
    onSubmit: (values) => {
      setFieldCode(values.field_code);
      setIsEditingFieldCode(false);
    },
  });
  const { handleSubmit } = formik;
  return (
    <FormikProvider value={formik}>
      <Styles>
        <Space direction="vertical" size={1}>
          <label>
            フィルードコード<span>*</span>
          </label>
          {isEditingFieldCode ? (
            <Space direction="horizontal">
              <FormikControl
                name="field_code"
                required
                control={CONTROL_TYPE.INPUT}
              />
              <Button onClick={() => handleSubmit()}>Save</Button>
              <Button type="text" onClick={() => setIsEditingFieldCode(false)}>
                Cancel
              </Button>
            </Space>
          ) : (
            <Space direction="horizontal" size={2}>
              {field_code}{" "}
              <Button
                type="text"
                shape="circle"
                onClick={() => setIsEditingFieldCode(true)}
              >
                <FaRegEdit />
              </Button>
            </Space>
          )}
        </Space>
      </Styles>
    </FormikProvider>
  );
};
